import { StateObject } from "../../redux/types"
import { MultiSelectItem } from "../../uiKit/MultiSelect/MultiSelect"
import { getLocationsAuthData } from "../../auth/selectors"
import { FiltersIdentifier } from "../../filters/types"
import { getFilters } from "../../filters/selectors"

export const getLocationsForLocationPicker = (state: StateObject): MultiSelectItem[] => {
    const locations = getLocationsAuthData(state)

    return locations.map(l => ({
        id: l.id,
        label: l.name,
    }))
}

export const getLocationPickerSelectedIds = (state: StateObject, identifier: FiltersIdentifier): string[] =>
    getFilters(state, identifier)?.location_name ?? []
